import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PathsService } from '@draeger-academy/common';
import { CartService } from '@draeger-academy/common/lib/services/cart/cart.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'da-cart',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CartComponent implements OnInit {
    public _$itemsNumber: BehaviorSubject<Number> = new BehaviorSubject(0);

    constructor(public cartService: CartService, private router: Router, private _pathsService: PathsService) {}

    public get itemsNumber$(): Observable<Number> {
        return this._$itemsNumber.asObservable();
    }

    ngOnInit() {
        this.cartService.itemsNumber().subscribe((itemsNumber) => {
            this._$itemsNumber.next(itemsNumber);
        });
    }

    goToCheckout() {
        const _checkoutPath = this._pathsService.getCheckoutLinkV2();
        this.router.navigate([_checkoutPath]).then(() => {
            this.cartService.activeStep(0);
        });
    }
}
